
import { useState } from "react";
import  "./MouthfeelIntensity.css";


const MouthfeelIntensity = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.mouthfeelbody===0?0:data.mouthfeelbody);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="MouthfeelIntensityradiocard" name="mouthfeelbody" onChange={onChangeValue}>
    <div class="MouthfeelIntensityrating-container">
      
      <div class="MouthfeelIntensityrating">
        <form class="MouthfeelIntensityrating-form-1" >

          <label for={`MFI1F-${count}`}>
        <input type="radio"  name="mouthfeelbody" class="MouthfeelIntensity1" id={`MFI1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>
  
          <label for={`MFI2F-${count}`}>
        <input type="radio" name="mouthfeelbody" class="MouthfeelIntensity2" id={`MFI2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>
  
          <label for={`MFI3F-${count}`}>
        <input type="radio" name="mouthfeelbody" class="MouthfeelIntensity3" id={`MFI3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>
  
          <label for={`MFI4F-${count}`}>
        <input type="radio" name="mouthfeelbody" class="MouthfeelIntensity4" id={`MFI4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>
       
        </label>
  
          <label for={`MFI5F-${count}`}>
        <input type="radio" name="mouthfeelbody" class="MouthfeelIntensity5" id={`MFI5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>
  

    );
}

export default MouthfeelIntensity;